import React from "react";

const SIDES = [
  { id: "south", label: "S" },
  { id: "west",  label: "W" },
  { id: "east",  label: "E" },
  { id: "north", label: "N" },
];

export default function HUD({ face, levels, currentSide, onSwitchSide, onExit, surround }) {
  const barW = (v) => `${Math.round(v * 100)}%`;
  return (
    <div
      className="hud-in"
      data-testid="hud"
      style={{
        position: "fixed", inset: 0, pointerEvents: "none", zIndex: 5,
        color: "var(--paper)", fontFamily: "var(--font-mono)",
      }}
    >
      {/* Top-left cluster: status + exit + side switcher */}
      <div style={{ position: "absolute", top: "clamp(16px, 2.5vh, 22px)", left: "clamp(16px, 2.5vw, 24px)", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--ink)", pointerEvents: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 8, height: 8, background: face?.hasFace ? "var(--neon-cyan)" : "var(--neon-magenta)", display: "inline-block", boxShadow: face?.hasFace ? "0 0 10px var(--neon-cyan)" : "0 0 10px var(--neon-magenta)" }} />
          <span data-testid="face-status">{face?.hasFace ? "tracking" : "searching for face"}</span>
        </div>
        <div style={{ marginTop: 6, opacity: 0.7 }}>Dard-e-Disco // node.03</div>
        <div style={{ marginTop: 4, display: "flex", alignItems: "center", gap: 6, fontSize: 9, opacity: 0.8, letterSpacing: "0.14em", color: "var(--ink-soft)" }}>
          <span style={{ width: 5, height: 5, borderRadius: "50%", background: "var(--neon-lime)", display: "inline-block", boxShadow: "0 0 6px var(--neon-lime)" }} />
          <span>CAM: 100% LOCAL [ISOLATED]</span>
        </div>

        {/* Exit + Side switcher */}
        <div style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 10 }}>
          <button
            data-testid="exit-btn"
            onClick={onExit}
            style={{
              padding: "8px 14px",
              background: "var(--ink)",
              color: "var(--paper)",
              border: "none",
              borderRadius: 999,
              fontFamily: "var(--font-mono)",
              fontSize: 10,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              cursor: "pointer",
              fontWeight: 700,
            }}
          >
            ← exit
          </button>
        </div>

        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 9, opacity: 0.7, marginBottom: 6 }}>switch side</div>
          <div data-testid="in-room-side-switcher" style={{ display: "grid", gridTemplateColumns: "repeat(4, 32px)", gap: 5 }}>
            {SIDES.map((s) => {
              const active = currentSide === s.id;
              return (
                <button
                  key={s.id}
                  data-testid={`switch-${s.id}`}
                  onClick={() => onSwitchSide(s.id)}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: active ? "var(--ink)" : "rgba(10,10,15,0.05)",
                    color: active ? "var(--paper)" : "var(--ink)",
                    border: `1.5px solid ${active ? "var(--ink)" : "rgba(10,10,15,0.25)"}`,
                    fontFamily: "var(--font-mono)",
                    fontWeight: 700,
                    fontSize: 12,
                    letterSpacing: "0.05em",
                    cursor: "pointer",
                    boxShadow: active ? "0 0 10px rgba(0,211,217,0.35)" : "none",
                  }}
                  title={s.id}
                >
                  {s.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Bottom-left: audio levels */}
      <div style={{ position: "absolute", bottom: "clamp(16px, 2.5vh, 22px)", left: "clamp(16px, 2.5vw, 24px)", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--ink)", width: "clamp(180px, 22vw, 260px)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <span style={{ color: "var(--neon-cyan)" }}>◆ window</span>
          <div style={{ flex: 1, height: 3, background: "rgba(10,10,15,0.15)" }}>
            <div data-testid="window-level" style={{ height: "100%", background: "var(--neon-cyan)", width: barW(levels?.ambient ?? 0), transition: "width 120ms linear" }} />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ color: "var(--neon-magenta)" }}>
            ◆ vinyl {surround && <span style={{ fontSize: 9, color: "var(--neon-cyan)", textShadow: "0 0 6px rgba(0,211,217,0.7)" }}>[surround]</span>}
          </span>
          <div style={{ flex: 1, height: 3, background: "rgba(10,10,15,0.15)" }}>
            <div data-testid="music-level" style={{ height: "100%", background: "var(--neon-magenta)", width: barW(levels?.music ?? 0), transition: "width 120ms linear" }} />
          </div>
        </div>
      </div>

      {/* Bottom-right hint */}
      <div className="font-serif" style={{ position: "absolute", bottom: "clamp(130px, 18vh, 160px)", right: "clamp(16px, 2.5vw, 24px)", fontSize: "clamp(16px, 1.6vw, 20px)", fontStyle: "italic", color: "var(--ink)", opacity: 0.75, maxWidth: 220, textAlign: "right", lineHeight: 1.15 }}>
        move your head.<br/>the room follows.
      </div>

      <div style={{ position: "absolute", top: "50%", left: "50%", width: 3, height: 3, background: "rgba(10,10,15,0.35)", borderRadius: "50%", transform: "translate(-50%,-50%)" }} />
    </div>
  );
}
